import React from 'react'
import { Table, Button } from 'reactstrap'
import '../../stylesheets/Provision.css'
import $ from 'jquery'
import { CSVLink } from 'react-csv';

class PaymentsReport extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            errors: [],
            loading: false,
        }
    }

    IsJsonString(str) {
        try {
            return JSON.parse(str);
        } catch (e) {
            return null;
        }
    }

    printReport = () => {
        $('.report-list').css("max-height", "100%");
        setTimeout(
            function () {
                window.print()
                $('.report-list').css("max-height", "375px");
            },
            500);
    }

    render() {
        let { paymentsdata } = this.props
        let csvData = []
        return (<div className="row justify-content-center align-items-center">
            {(paymentsdata.length > 0 ?
                <div id="provisioned-controllers" className="row justify-content-center align-items-center">
                    <h3 className="col-12">Payments Report</h3>
                    <div className="report-list">
                        <Table>
                            <tbody>
                            <tr>
                                <th>Transaction ID</th>
                                <th>Paid By</th>
                                <th>Amount</th>
                                <th>Payment Date</th>
                            </tr>
                            {paymentsdata.map((data, idx) => {
                                let date = new Date(data.payment_date)
                                let month = ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1))
                                let day = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
                                let year = date.getFullYear()
                                let detail = this.IsJsonString(data.detail)
                                csvData.push({
                                    'Transaction ID': data.random_transaction_id,
                                    'Paid By': data.paid_by,
                                    'Amount': detail ? ('$ ' + (detail.amount) / 100) : '--',
                                    'Payment Date': month + '-' + day + '-' + year
                                });
                                return (
                                    <tr key={`${idx}`}>
                                        <td>{data.random_transaction_id}</td>
                                        <td>{data.paid_by}</td>
                                        <td>{detail ? ('$ ' + (detail.amount) / 100) : '--'}</td>
                                        <td>{month + '-' + day + '-' + year}</td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </Table>
                    </div>
                    <br />
                    <CSVLink data={csvData} filename={"Payment-Report.csv"} className="noprint btn btn-primary export-excel-btn">
                        Export to Excel
                    </CSVLink>
                    <Button className="noprint report-print-btn" color="primary" onClick={this.printReport}>
                        Print
                    </Button>
                </div>
                : null)}
        </div>)
    }
}

export default PaymentsReport



// WEBPACK FOOTER //
// ./src/components/ui/PaymentsReport.js